module.exports = __webpack_public_path__ + "static/media/ship-solid.4d2888af.svg";